import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { isEqual } from 'lodash';
import { Tag } from '../../../../interfaces/tag';
import { SwapIface } from '../../../../interfaces/swap.iface';
import { OfferIface } from '../../../../interfaces/offer.iface';
import { SingleSwapIface } from '../../../../interfaces/single-swap.iface';
import { DataHelper } from '../../../../helpers/data-helper';
import { OffersService } from '../../../../services/offers.service';
import { OffersMassEditionService } from '../../../../services/offers-mass-edition.service';

@Component({
  selector: 'app-swaps',
  templateUrl: './swaps.component.html',
  styleUrls: ['./swaps.component.scss']
})
export class SwapsComponent {
  @Output()
  updateTable = new EventEmitter<any>();
  public multipleSwaps: SwapIface[] = [];
  public singleSwaps: SingleSwapIface[] = [];
  public activeSwap = -1;

  constructor(private offersService: OffersService, private offersMassEditionService: OffersMassEditionService) {}

  addSwap(): void {
    this.multipleSwaps.push({
      offersIds: [],
      activeInputs: [],
      activeTags: [],
      isToggled: false,
      color: DataHelper.getRandomColor()
    });
    this.activeSwap = this.multipleSwaps.length - 1;
    this.offersService.findAllMatchingIds({});
    this.offersMassEditionService.multipleSwaps = this.multipleSwaps;
    this.updateTable.emit([]);
  }

  deleteSwap(index: number): void {
    this.multipleSwaps.splice(index, 1);
    this.activeSwap = this.multipleSwaps.length - 1;
    this.offersMassEditionService.updateModifiedOffersIds();
    this.offersMassEditionService.multipleSwaps = this.multipleSwaps;
    this.updateTable.emit();
  }

  changeInputValue(value: string, input: object) {
    input['value'] = value;
  }

  addSwapOption(name: string): void {
    if (this.isActiveSwapNotEditable()) {
      return;
    }
    const propertyName = DataHelper.mapHeadersToProp(name);
    const idx = this.multipleSwaps[this.activeSwap].activeInputs.findIndex(input => input.name === name);
    if (this.multipleSwaps[this.activeSwap].activeInputs.length && ~idx) {
      this.multipleSwaps[this.activeSwap].activeInputs.splice(idx, 1);
    } else {
      this.multipleSwaps[this.activeSwap].activeInputs.push({ name, propertyName, value: '' });
    }
  }

  isActiveSwapNotEditable(): boolean {
    return this.activeSwap < 0 || this.multipleSwaps[this.activeSwap].isToggled;
  }

  swapOffers(isToggled: boolean, currentSwap: SwapIface): void {
    currentSwap.isToggled = isToggled;
    if (isToggled) {
      currentSwap.offersIds = this.offersMassEditionService.selectedOffers
        .filter(offer => offer.selected)
        .map(offer => offer.id);
    }
    this.offersMassEditionService.updateModifiedOffersIds();
    this.offersMassEditionService.multipleSwaps = this.multipleSwaps;
    this.updateTable.emit();
  }

  toggleTag(tag: Tag): MatTableDataSource<OfferIface> | boolean {
    if (this.isActiveSwapNotEditable()) {
      return false;
    }
    const tagIndex = this.multipleSwaps[this.activeSwap].activeTags.findIndex(activeTag => isEqual(activeTag, tag));
    if (tagIndex > -1) {
      this.multipleSwaps[this.activeSwap].activeTags.splice(tagIndex, 1);
    } else {
      this.multipleSwaps[this.activeSwap].activeTags.push(tag);
    }
    if (!this.multipleSwaps[this.activeSwap].activeTags.length) {
      this.updateTable.emit();
    }
    this.updateTable.emit();
    const activeTags = this.multipleSwaps[this.activeSwap].activeTags.map(activeTag => activeTag.value);
    const query = activeTags.length ? { 'tags.value': { $all: activeTags } } : {};
    this.offersService.findAllMatchingIds(query);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/offers/campaigns/swaps/swaps.component.ts